import { NgModule } from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { AccordionModule } from 'primeng/accordion';
import { ToastModule } from 'primeng/toast';
import { CalendarModule } from 'primeng/calendar';
import { SidebarModule } from 'primeng/sidebar';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TabMenuModule } from 'primeng/tabmenu';
import { TabViewModule } from 'primeng/tabview';
import { CheckboxModule } from 'primeng/checkbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { PickListModule } from 'primeng/picklist';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { StepsModule } from 'primeng/steps';
import { FieldsetModule } from 'primeng/fieldset';
import { PanelModule } from 'primeng/panel';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { SplitButtonModule } from 'primeng/splitbutton';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CarouselModule } from 'primeng/carousel';
import { ContextMenuModule } from 'primeng/contextmenu';
import { OrderListModule } from 'primeng/orderlist';
import { InputNumberModule } from 'primeng';

import { PrimeUtilServices } from './prime-utils.service';

@NgModule({
    imports: [
        InputTextModule,
        DropdownModule,
        ButtonModule,
        AccordionModule,
        FieldsetModule,
        PanelModule,
        ToastModule,
        CalendarModule,
        SidebarModule,
        AutoCompleteModule,
        TabMenuModule,
        TabViewModule,
        CheckboxModule,
        MultiSelectModule,
        PickListModule,
        FileUploadModule,
        InputTextareaModule,
        DynamicDialogModule,
        ConfirmDialogModule,
        DialogModule,
        TooltipModule,
        StepsModule,
        InputSwitchModule,
        OverlayPanelModule,
        SplitButtonModule,
        RadioButtonModule,
        CarouselModule,
        ContextMenuModule,
        OrderListModule,
		InputNumberModule
    ],
    exports: [
        InputTextModule,
        DropdownModule,
        ButtonModule,
        AccordionModule,
        ToastModule,
        FieldsetModule,
        PanelModule,
        CalendarModule,
        SidebarModule,
        AutoCompleteModule,
        TabMenuModule,
        TabViewModule,
        CheckboxModule,
        MultiSelectModule,
        PickListModule,
        FileUploadModule,
        InputTextareaModule,
        DynamicDialogModule,
        DialogModule,
        TooltipModule,
        StepsModule,
        InputSwitchModule,
        ConfirmDialogModule,
        OverlayPanelModule,
        SplitButtonModule,
        RadioButtonModule,
        CarouselModule,
        ContextMenuModule,
        OrderListModule,
		InputNumberModule
    ],
    providers: [
        PrimeUtilServices
    ]
})
export class PrimengModule { }
